<template>
  <v-row class="mb-1" v-if="!onlyAndroid || (onlyAndroid && isAndroidApp)">
    <v-col cols="auto" class="py-1">
      <v-btn
        v-if="close"
        icon
        class="close-btn"
        aria-label="Cerrar"
        @click.stop.prevent="onBack"
      >
        <v-icon>{{ resolvedIcon }}</v-icon>
      </v-btn>
      <v-btn
        v-else
        text
        color="primary"
        class="back-link"
        :ripple="false"
        @click.stop.prevent="onBack"
      >
        <v-icon left>{{ resolvedIcon }}</v-icon>
        {{ label || 'Volver' }}
      </v-btn>
    </v-col>
  </v-row>
</template>
<script>
import { goBackToCatalog } from '@/helpers/catalogScroll.js'

export default {
  props: {
    routeName: {
      type: [String, Object],
      default: null
    },
    /**
     * Si es true, siempre navega a routeName (no history.back / catálogo guardado).
     * Usar en home de tienda → lista de tiendas/sucursales.
     */
    forceRoute: {
      type: Boolean,
      default: false
    },
    onlyAndroid: {
      type: Boolean,
      default: false
    },
    close: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: null
    }
  },
  name: 'GoBack',
  computed: {
    isAndroidApp () {
      try {
        return !!(window && window.Capacitor && window.Capacitor.getPlatform && window.Capacitor.getPlatform() === 'android')
      } catch (e) {
        return false
      }
    },
    resolvedIcon () {
      if (this.icon) return this.icon
      return this.close ? 'mdi-close' : 'mdi-arrow-left'
    }
  },
  methods: {
    onBack () {
      if (this.forceRoute && this.routeName) {
        this.$router.push(this.routeName).catch(() => {})
        return
      }
      goBackToCatalog(this.$router, this.routeName)
    }
  }
}
</script>
<style scoped>
.close-btn {
  background: rgba(0, 0, 0, 0.04) !important;
}
.back-link {
  text-transform: none !important;
  letter-spacing: 0 !important;
  font-weight: 600 !important;
  padding-left: 4px !important;
  padding-right: 8px !important;
}
</style>
